const getters = {
	token: state => state.user.token,
	role: state => state.user.role,
	routes: state => state.permission.routes,
	addRoutes: state => state.permission.addRoutes,
}
export default getters